<template>
  <div v-show="isActive" class="popup-wrap transfer" :class="{ active: isActive }">
    <div class="popup-box popup-transfer">
      <a class="popup-close" @click="hideTransferModal"><i class="fa-solid fa-xmark" /></a>

      <div class="form-popup popup-padding">
        <div class="reg-form-area">
          <h4 class="text-center">
            {{ $t('Bao.transfer_to_main') }}
          </h4>
          <div class="transfer-frame">
            <div>{{ $t('Bao.trading_balance') }}</div>
            <div class="right-area">
              <span class="balance fs-14px">{{ $store.state.brand.currency }}{{ tradingBalance }}</span>
            </div>
          </div>
          <form class="row-frame colu-12 reg-popupBox" @submit.prevent="submitForm">
            <div class="colu">
              <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="amount">{{ $t('Bao.transfer_amount') }}</label>
              <div class="colu-sm-12 colu-md-8 colu-12">
                <input
                  id="amount"
                  v-model="amount"
                  class="colu-12 for-input inpType"
                  type="text"
                >
              </div>
            </div>
            <div v-if="!isAmountValid" class="input-feedback text-align-R">
              {{ $t('Bao.transfer_error') }}
            </div>
            <div class="row-frame colu message-con">
              <i class="colu-1 icon-alert mr-1">
                <img :src="$getThemeImagePath('icon-alert.png')">
              </i>
              <p class="colu-11 tips-text">
                {{ $t('Bao.withdraw_multiply') }}
              </p>
            </div>
            <div class="form-button form-ft">
              <button :disabled="!isAmountValid" type="submit" class="btn btn-primary text-center">
                {{ $t('Bao.transfer') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commissionToMain } from '@/api/payment'
import { showNotice } from '@/utils/tool'

export default {
  name: 'TransferModal',
  props: {
    isActive: Boolean,
    tradingBalance: {
      type: String,
      default: () => ('')
    }
  },
  data() {
    return {
      amount: ''
    }
  },
  computed: {
    isAmountValid() {
      const number = parseFloat(this.amount)
      return Number.isInteger(number) && number > 0
    }
  },
  methods: {
    hideTransferModal() {
      this.$emit('hideTransferModal')
    },
    submitForm() {
      if (this.isAmountValid) {
        commissionToMain({ amount: this.amount }).then((result) => {
          this.amount = ''
          showNotice(this.$t('Bao.transfer_success'))
          this.$emit('hideTransferModal')
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
}
</script>
